import { ArrowLeft } from 'lucide-react';
import { cameFrom } from '../lib/route';

// "← Alert queue (C1)" above a detail page's title. When the page was opened from that list, it goes back in history,
// so the list returns with its filters and scroll position; otherwise (a link, a bookmark, a reload) it opens the list.
export function BackLink({ label, to, go }: { label: string; to: string; go: (path: string) => void }) {
  const back = () => {
    const from = cameFrom();
    if (from && from.split('?')[0] === to) window.history.back(); else go(to);
  };
  return (
    <button type="button" onClick={back} className="mb-2 inline-flex items-center gap-1 text-sm font-semibold text-tick-ink hover:underline">
      <ArrowLeft className="size-4" aria-hidden />{label}
    </button>
  );
}
